import _ from 'lodash';
import PropTypes from 'prop-types';
import { Box, Breadcrumbs, Container, Link, Typography } from '@mui/material';

import { PATH_HONHAI } from '../../router/paths';

// ===========================|| MENU ITEMS BREADCRUMBS ||=========================== //
export const MenuItems = {
  items: [
    {
      id: 'group-dashboard',
      title: 'Navigation',
      type: 'group',
      children: [
        {
          id: 'service',
          title: '服務',
          type: 'item',
          url: `${PATH_HONHAI.root}/service`,
          breadcrumbs: true
        },
        {
          id: 'resource-download',
          title: '資源與下載',
          type: 'item',
          url: `${PATH_HONHAI.root}/resource-download`,
        },
        {
          id: 'faqs',
          title: '常見問題',
          type: 'item',
          url: `${PATH_HONHAI.root}/faqs`,
        },
        {
          id: 'about',
          title: '關於我們',
          type: 'item',
          url: `${PATH_HONHAI.root}/about`,
        }
      ]
    },
    {
      id: 'authentication',
      title: 'Authentication',
      type: 'group',
      children: [
        {
          id: 'login1',
          title: 'Login',
          type: 'item',
          url: '/login',
          target: true
        },
        {
          id: 'register1',
          title: 'Register',
          type: 'item',
          url: '/register',
          target: true
        }
      ]
    },
    {
      id: 'support',
      title: 'Support',
      type: 'group',
      children: [
        {
          id: 'sample-page',
          title: 'Sample Page',
          type: 'item',
          url: '/sample-page',
        },
        {
          id: 'documentation',
          title: 'Documentation',
          type: 'item',
          url: '',
          external: true,
          target: true
        }
      ]
    },
    {
      id: 'utilities',
      title: 'Utilities',
      type: 'group',
      children: [
        {
          id: 'util-typography',
          title: '服務',
          type: 'item',
          url: `${PATH_HONHAI.root}/typography`,
        },
        {
          id: 'util-color',
          title: 'Color',
          type: 'item',
          url: '/color',
        },
        {
          id: 'util-shadow',
          title: 'Shadow',
          type: 'item',
          url: '/shadow',
        },
        {
          id: 'ant-icons',
          title: 'Ant Icons',
          type: 'item',
          url: '/icons/ant',
          breadcrumbs: false
        }
      ]
    }
  ]
}


// ================================|| PAGE Collapse BREADCRUMBS ||================================ //
// export const SimCollapseBreadcrumbs = ({ navigation, title, ...others }) => {
//   const { t } = useTranslation();
//   const theme = useTheme();
//   const location = useLocation();
//   const [main, setMain] = useState();
//   const [item, setItem] = useState();

//   // set active item state
//   const getCollapse = (menu) => {
//     if (menu.children) {
//       menu.children.filter((collapse) => {
//         if (collapse.type && collapse.type === 'collapse') {
//           getCollapse(collapse);
//         } else if (collapse.type && collapse.type === 'item') {
//           if (location.pathname === collapse.url) {
//             setMain(menu);
//             setItem(collapse);
//           }
//         }
//         return false;
//       });
//     }
//   };

//   useEffect(() => {
//     navigation?.items?.map((menu) => {
//       if (menu.type && menu.type === 'group') {
//         getCollapse(menu);
//       }
//       return false;
//     });
//   });

//   let mainContent;
//   let itemContent;
//   let breadcrumbContent = <Typography />;
//   let itemTitle = '';

//   // collapse item
//   if (main && main?.type === 'collapse') {
//     mainContent = (
//       <Typography component={Link} to={document.location.pathname} variant="h6" sx={{ textDecoration: 'none' }} color="textSecondary">
//         {main?.title}
//       </Typography>
//     );
//   }

//   // items
//   if (item && item?.type === 'item') {
//     itemTitle = item?.title;
//     itemContent = (
//       <Typography variant="subtitle1" color="textPrimary">
//         {itemTitle}
//       </Typography>
//     );

//     // main
//     if (item?.breadcrumbs !== false) {
//       breadcrumbContent = (
//         <Container
//           maxWidth={'lg'}
//           sx={{
//             [theme.breakpoints.up('lg')]: {
//               p: 0
//             },
//             [theme.breakpoints.down('lg')]: {
//               // px: 2.5
//             },
//           }}
//         >
//           <Breadcrumbs
//             aria-label="breadcrumb"
//             separator={
//               <Box
//                 width={2}
//                 height={2}
//                 sx={{ backgroundColor: theme => theme.palette.error.main }}
//               />
//             }
//             sx={{ mb: 2.5 }}
//           >
//             <Typography component={Link} to="/" color="common.white" variant="h6" fontSize={16} sx={{ textDecoration: 'none' }}>
//               首頁
//             </Typography>
//             {mainContent}
//             {itemContent}
//           </Breadcrumbs>
//           {title && (<Typography variant="h5">{item?.title}</Typography>)}
//         </Container>
//       );
//     }
//   }


//   return breadcrumbContent;
// };
// SimBreadcrumbs.propTypes = {
//   navigation: PropTypes.object,
//   title: PropTypes.bool
// };


// ==================================|| PAGES DEFAULT ||================================= //
export { default as MantisPage } from './MantisPage';
export { default as MainPage } from './MainPage';

export { default as SubPage } from './SubPage';
export { default as ZonePage } from './ZonePage';
export { default as LauanPage } from './LauanPage';

export { default as PageBody } from './PageBody';

export { default as PageBreadcrumbs } from './PageBreadcrumbs';
export { default as PageHandleBreadcrumbs } from './PageHandleBreadcrumbs';
export { default as PageLauanBreadcrumbs } from './PageLauanBreadcrumbs';